import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import AssumedTenantBanner from "./AssumedTenantBanner";
import { TID } from "@/constants/testIds";

export default function AppShell({ children }) {
  return (
    <div data-testid={TID.appShell} className="min-h-screen flex bg-background text-foreground">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <AssumedTenantBanner />
        <main className="flex-1 px-6 md:px-8 py-6 max-w-[1600px] w-full">
          {children}
        </main>
        <footer className="border-t border-border px-6 py-4 text-[11px] text-muted-foreground flex items-center justify-between">
          <div>
            © {new Date().getFullYear()} Altara · Part of the Navigate Group (Pty) Ltd · Johannesburg, South Africa
          </div>
          <div className="flex items-center gap-3">
            <span>Consumer Trust Infrastructure Platform</span>
            <span className="text-altara-teal">·</span>
            <span className="font-mono">v0.1.0</span>
          </div>
        </footer>
      </div>
    </div>
  );
}
